// Module
var code = `<div>
	<div
		class="alert alert-dismissible"
		role="alert"
		ng-repeat="alert in \$ctrl.alerts"
		ng-class="'alert-' + alert.type"
	>
		<button
			type="button"
			class="btn-close"
			aria-label="Close"
			ng-click="\$ctrl.close(\$index)"
		>
		</button>
		<i
			class="fa"
			ng-class="{ 'fa-circle-exclamation': alert.type === 'danger', 'fa-triangle-exclamation': alert.type === 'warning'}"
			aria-hidden="true"
		></i>
		<span>{{alert.msg}}</span>
	</div>
</div>
`;
// Exports
export default code;